import React from "react";

import { useNavigate } from "react-router-dom";
import { StartConversation } from "../Casinoengine/StartConversation";

const CasinoService = () => {
  const navigate = useNavigate();
  const featuresData = [
    {
      title: "Proactive Account Management",
      description:
        "A dedicated Account Manager focused on training, partnership growth, and maximizing your revenue potential through strategic insights and support.",
    },
    {
      title: "Around-the-Clock Incident Resolution",
      description:
        "A skilled Incident Management team ensures service restoration and issue resolution 24/7, keeping all stakeholders updated in real-time.",
    },
    {
      title: "24/7 Casino Support Services",
      description:
        "A specialized team providing thorough investigations for client websites, games, players, winnings, bonuses, and other operational concerns.",
    },
  ];

  const componentsData = [
    {
      title: "Streamlined Operations",
      content: [
        "CasinoEngine manages game releases, upgrades, and compliance updates, while delivering 24/7 monitoring, provider communication, and operational support.",
        "Clients save valuable time and resources on content maintenance and upgrades, as our team handles all operational tasks to simplify their workflow.",
      ],
    },
    {
      title: "Rapid Market Expansion",
      content: [
        "CasinoEngine’s modular architecture supports both partial and full integrations, enabling seamless market entry from both technical and operational perspectives.",
        "Gain access to essential content within 48 hours. We onboard new game providers upon request and ensure compliance with local regulations.",
      ],
    },
  ];

  const managedServicesData = {
    title: "Modular Managed Services",
    paragraphs: [
      "From marketing and retention to responsible gaming and payments management, we support your executive teams at every stage of operations. As the license holder, you always maintain full control—our role is to enhance and assist.",
      "Our Managed Services are designed modularly—just like our products—allowing you to choose comprehensive support or focus on specific operational areas.",
    ],
    listItems: [
      "Marketing Strategy & Execution",
      "Affiliate Program Oversight",
      "CRM Operations & Campaigns",
      "VIP Customer Relationship Management",
      "Product Lifecycle Management",
      "Payment Processing & Fraud Prevention",
      "Bonus Abuse Detection",
      "Responsible Gaming Programs",
      "Customer Support Services",
    ],
    image: {
      src: "https://everymatrix.com/wp-content/uploads/2021/12/CE-Service-img4-1.png",
      alt: "Managed services",
    },
  };

  const { title, paragraphs, listItems, image } = managedServicesData;
  return (
    <>
      <main className="overflow-hidden">
        <section className="simple-intro service_first">
          <div className="container container_custom">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-6">
                <h1 className="section-title heading_left">
                  Committed to Delivering Outstanding Service
                </h1>
                <div className="description">
                  <p>
                  Our team is dedicated to maintaining strong vendor integrations while providing continuous support and actionable feedback. We collaborate closely with clients to evaluate their gaming portfolio, refine key performance indicators, and drive revenue growth.

                  </p>
                </div>
                <div className="btns pt-5">
                  <a href="/connect" className="btn btn_blue">
                    Contact us
                  </a>
                </div>
              </div>
              <div className="img-holder">
                <img
                  src="https://everymatrix.com/wp-content/uploads/2019/05/CE-Service.png"
                  className="illustration service_img"
                />
              </div>
            </div>
          </div>
          <a href="#explore" className="explore"></a>
        </section>

        <section className="features service_feature">
          <div className="container container_custom">
            <div className="row">
              {featuresData.map((item, index) => (
                <div className="col" key={index}>
                  <div className="inner">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="components sec-padd">
          <div className="container">
            <div className="row g-md-5 g-4">
              {componentsData.map((item, index) => (
                <div className="col-xl-6" key={index}>
                  <div className="inner">
                    <h3 className="section-title">{item.title}</h3>
                    <div>
                      {item.content.map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="managed-services sec-padd-b box-full m-t-50 m-b-50">
          <div className="container">
            <div className="row">
              <div className="col box">
                <div className="inner">
                  <div className="inner-content">
                    <div className="row  justify-content-between align-items-center">
                      <div className="col-lg-5">
                        <h3 className="section-title text-left">{title}</h3>
                        <div className="description">
                          {paragraphs.map((text, index) => (
                            <p key={index}>{text}</p>
                          ))}
                          <ul>
                            {listItems.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-5  ">
                        <img src={image.src} alt={image.alt} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <StartConversation />
      </main>
    </>
  );
};

export default CasinoService;
